var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"component-sub-frame-page",style:({ height: _setup.windowHeight })},[_c(_setup.SimpleVScroll,[_c(_setup.SmartDisplayC,{attrs:{"compId":_setup.activeModuleId,"mode":_setup.getDisplayType}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }